const BackButton = ({ onBack, patientName }) => {
    return(
  <div className="d-flex flex-column align-items-start mb-3">
    <button
      className="btn mb-2 text-capitalize p-2"
      onClick={onBack}
      style={{
        top: '120px',
        borderColor: 'var(--pmr-primary)',
        backgroundColor: 'var(--pmr-primary)',
        color: '#fff',
        display: 'inline-block',
        fontWeight: 600,
        textAlign: 'center',
        verticalAlign: 'middle',
        userSelect: 'none',
        border: '1px solid var(--pmr-primary)',
        padding: '.9rem 2.2rem',
        fontSize: '1.1rem',
        lineHeight: 1,
        borderRadius: '.358rem',
        transition:
          'color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, background 0s, border 0s',
        width: 'auto',
        minWidth: '120px',
        alignItems: 'center',
      }}
    >
      <span style={{ fontSize: '15px', lineHeight: 1 }}>
        <i className="fa fa-arrow-left"></i>
      </span>{' '}
      Back
    </button>
    <span style={{ fontWeight: 'bold', marginTop: '10px' }}>
      You are viewing{' '}
      {patientName ? (
        <>
          <span className="text-danger" style={{ fontSize: '13px' }}>
            {patientName}
          </span>{' '}
          details
        </>
      ) : (
        'details'
      )}
    </span>
  </div>
)};

export default BackButton;